/**
 * Projects Redux Reducer
 */

import * as action from '../actions/projects';

import { Success } from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

type ReducerState = IProjectsState;
type Handler<K = undefined> = ReducerHandler<ReducerState, K>;

const defaultList = [];
const initialState: ReducerState = {};

const setProjectsHandler: Handler<ISetProjectsActionPayload> =
  (state, { projects }) => projects.reduce((acc, project) => {
    acc[project.id] = project.tracks ? project.tracks!.edges!.map(({ id }) => id) : defaultList;
    return acc;
  }, {});

const addTrackToProjectHandler: Handler<Success<IAddTrackToProjectActionPayload, IMutationResult>> =
  (state, { params: { projectId, trackId } }) => ({
    ...state,
    [projectId]: [
      ...(state.hasOwnProperty(projectId) ? state[projectId] : defaultList),
      trackId,
    ],
  });

export default reducerWithInitialState(initialState)
  .case(action.setProjects, setProjectsHandler)
  .case(action.addTrackToProject.done, addTrackToProjectHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/projects.ts